import styled from "styled-components";

const Input = styled.input`
  width: 100%;
  height: 100%;
  border: none;
  background-color: #ffffff;
  color: #000000;
  font-size: 16px;
  padding: 16px;
  box-sizing: border-box;
  border-radius: 16px;
  ::placeholder {
    color: #8c9aa7;
  }
  outline: none;
  &::-moz-focus-inner {
    border: 0;
  }
  :focus {
    border: 2px solid #735cdd;
    padding: 14px
  }
  &:disabled {
    opacity: 1;
    background-color: #dae0e7;
    ::placeholder {
      opacity: 0.5;
    }
  }
`;

export default Input;
